export default "__VITE_ASSET__b4964979__"